const mockAuctionData = (): Array<{ label: string; id: string }> => {
  return [
    { label: 'auction', id: 'auction' },
    { label: 'auction1', id: 'auction1' },
    { label: 'auction2', id: 'auction2' },
    { label: 'auction3', id: 'auction3' },
    { label: 'auction4', id: 'auction4' },
    { label: 'auction5', id: 'auction5' }
  ];
};

const mockDateData = (): Array<{ label: string; value: string }> => {
  return [
    { label: '08/12/2022', value: '08/12/2022' },
    { label: '08/13/2022', value: '08/13/2022' },
    { label: '08/14/2022', value: '08/14/2022' },
    { label: '08/15/2022', value: '08/15/2022' },
    { label: '08/16/2022', value: '08/16/2022' },
    { label: '08/17/2022', value: '08/17/2022' },
    { label: '08/18/2022', value: '08/18/2022' },
    { label: '08/19/2022', value: '08/19/2022' }
  ];
};

const mockAccountData = (): Array<{ label: string; id: string }> => {
  return [
    { label: 'account', id: 'account' },
    { label: 'account1', id: 'account1' },
    { label: 'account2', id: 'account2' },
    { label: 'account3', id: 'account3' },
    { label: 'account4', id: 'account4' },
    { label: 'account5', id: 'account5' }
  ];
};

const mockPreferredData = (): Array<{ label: string; value: string }> => {
  return [{ label: '', value: '' }];
};

export const requestRunsHelper = {
  mockAuctionData,
  mockDateData,
  mockAccountData,
  mockPreferredData
};
